import React, { useRef } from 'react';
import { Dialog } from '@mui/material';
import {
  MainContainer,
  CloseButton,
  ContentContainer,
  IconContainer,
  Title,
  Message,
  ActionButton,
  ButtonGroup,
  CheckboxContainer,
  Checkbox,
  CheckboxLabel,
  ContentWrapper,
  ArrowIcon,
} from './style';
import CloseIcon from '../../static/img/closecircle24gray.svg';
import { CheckIcon } from '../../components/ReportIssuePopup/icons';
import { useProfile } from '../../components/state/hooks';
import { neverShowSharedResourcePopup } from '../../service';
import Loader from '../../components/Loader';

const ActionPopup = ({
  open,
  onClose,
  type = 'share',
  title,
  message,
  emailList = [],
  primaryButtonLabel,
  primaryButtonAction,
  secondaryButtonLabel,
  secondaryButtonAction,
  showCheckbox = false,
  checkboxLabel = "Don't show this popup again",
  onCheckboxChange,
  showDottedBorder = false,
}) => {
  const { data: profile, isLoadingdata: isLoadingProfile, resetData: resetProfile } = useProfile();
  const checkboxRef = useRef(null);

  const checkboxChecked = profile?.showSharedResourcesPopup === false;

  if (isLoadingProfile) {
    return (
      <Loader />
    );
  }

  const handleCheckboxChange = (e) => {
    if (onCheckboxChange) {
      onCheckboxChange(e.target.checked);
    }
  };

  const handlePrimaryAction = () => {
    if (primaryButtonAction) {
      primaryButtonAction();
    } else {
      onClose();
    }
  };

  const handleClose = async () => {
    const isChecked = checkboxRef.current?.checked;
    if (isChecked && showCheckbox) {
      try {
        await neverShowSharedResourcePopup();
        resetProfile();
      } catch (error) {
        console.error('Failed to update popup preference:', error);
      }
    }
    onClose();
  };

  const handleSecondaryAction = () => {
    if (secondaryButtonAction) {
      secondaryButtonAction();
    }
  };

  const renderContent = () => {
    if (type === 'success') {
      return (
        <>
          <IconContainer>
            <CheckIcon />
          </IconContainer>
          {message && <Message>{message}</Message>}
          {primaryButtonLabel && (
            <ActionButton primary onClick={handlePrimaryAction}>
              {primaryButtonLabel}
              <ArrowIcon width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 12L10 8L6 4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </ArrowIcon>
            </ActionButton>
          )}
        </>
      );
    }

    if (type === 'reject') {
      return (
        <>
          {title && <Title>{title}</Title>}
          {message && <Message>{message}</Message>}
          <ButtonGroup>
            {secondaryButtonLabel && (
              <ActionButton secondary onClick={handleSecondaryAction}>
                {secondaryButtonLabel}
              </ActionButton>
            )}
            {primaryButtonLabel && (
              <ActionButton danger onClick={handlePrimaryAction}>
                {primaryButtonLabel}
              </ActionButton>
            )}
          </ButtonGroup>
        </>
      );
    }

    return (
      <>
        <IconContainer>
          <CheckIcon />
        </IconContainer>
        {message && <Message>{message}</Message>}
        {primaryButtonLabel && (
          <ActionButton primary onClick={handlePrimaryAction}>
            {primaryButtonLabel}
          </ActionButton>
        )}
      </>
    );
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <MainContainer>
        <CloseButton src={CloseIcon} onClick={handleClose} />
        <ContentWrapper showDottedBorder={showDottedBorder}>
          <ContentContainer showDottedBorder={showDottedBorder}>{renderContent()}</ContentContainer>
          {type === 'success' && showCheckbox && (
            <CheckboxContainer>
              <Checkbox
                ref={checkboxRef}
                type="checkbox"
                defaultChecked={checkboxChecked}
                onChange={handleCheckboxChange}
              />
              <CheckboxLabel>{checkboxLabel}</CheckboxLabel>
            </CheckboxContainer>
          )}
        </ContentWrapper>
      </MainContainer>
    </Dialog>
  );
};

export default ActionPopup;
